/* Cockpitélys : comportements légers, sans dépendance */
(function () {
  'use strict';

  /* 1. Accueil : l'en-tête apparaît une fois l'écran d'ouverture dépassé */
  function initSplash() {
    var splash = document.querySelector('[data-ck-splash]');
    var body = document.body;
    if (!splash) { body.classList.add('ck-past-splash'); return; }
    /* Horizon fait défiler .page-wrapper sur ordinateur, la fenêtre sur mobile */
    var wrapper = document.querySelector('.page-wrapper');
    function update() {
      var limit = splash.offsetHeight - 80;
      var y = Math.max(window.scrollY, wrapper ? wrapper.scrollTop : 0);
      body.classList.toggle('ck-past-splash', y > limit);
    }
    window.addEventListener('scroll', update, { passive: true });
    if (wrapper) wrapper.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* 2. Menu mobile */
  function initDrawer() {
    var drawer = document.querySelector('[data-ck-drawer]');
    if (!drawer) return;
    var openers = document.querySelectorAll('[data-ck-drawer-open]');
    var lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      drawer.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var first = drawer.querySelector('[data-ck-drawer-close]');
      if (first) first.focus();
    }
    function close() {
      drawer.hidden = true;
      document.documentElement.style.overflow = '';
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (lastFocus) lastFocus.focus();
    }
    openers.forEach(function (b) { b.addEventListener('click', open); });
    drawer.querySelectorAll('[data-ck-drawer-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });
  }

  /* 3. Sélecteur « trouvez l'écran de votre voiture » */
  function initFinder() {
    document.querySelectorAll('[data-ck-finder]').forEach(function (root) {
      var dataEl = root.querySelector('script[type="application/json"]');
      if (!dataEl) return;
      var items;
      try { items = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var brandSel = root.querySelector('[data-ck-brand]');
      var modelSel = root.querySelector('[data-ck-model]');
      var go = root.querySelector('[data-ck-go]');
      var brands = [];
      items.forEach(function (it) { if (brands.indexOf(it.brand) === -1) brands.push(it.brand); });
      brandSel.innerHTML = brands.map(function (b) { return '<option>' + b + '</option>'; }).join('');
      function fillModels() {
        var b = brandSel.value;
        modelSel.innerHTML = items.filter(function (it) { return it.brand === b; })
          .map(function (it) { return '<option value="' + it.url + '">' + it.model + '</option>'; }).join('');
      }
      brandSel.addEventListener('change', fillModels);
      fillModels();
      root.querySelector('form').addEventListener('submit', function (e) {
        e.preventDefault();
        if (modelSel.value) window.location.href = modelSel.value;
      });
      if (go) go.disabled = false;
    });
  }

  /* 4. Galerie de la fiche : vignettes et repères */
  function initGallery() {
    document.querySelectorAll('[data-ck-gallery]').forEach(function (root) {
      var main = root.querySelector('[data-ck-main]');
      if (!main) return;
      var dots = root.querySelectorAll('[data-ck-dot]');
      var thumbs = document.querySelectorAll('[data-ck-thumb]');
      function show(src, srcset, alt, idx) {
        main.src = src;
        if (srcset) main.srcset = srcset; else main.removeAttribute('srcset');
        main.alt = alt || '';
        dots.forEach(function (d, i) { d.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
      }
      function bind(el) {
        el.addEventListener('click', function () {
          show(el.dataset.src, el.dataset.srcset, el.dataset.alt, parseInt(el.dataset.index, 10));
          if (el.hasAttribute('data-ck-thumb') && window.innerWidth < 990) main.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
      dots.forEach(bind);
      thumbs.forEach(bind);
    });
  }

  /* 5. Choix de version : prix, disponibilité et image */
  function initVariants() {
    document.querySelectorAll('[data-ck-variant-select]').forEach(function (sel) {
      var form = sel.closest('form');
      var priceEl = document.querySelector('[data-ck-price]');
      var btn = form.querySelector('[type="submit"]');
      function update() {
        var opt = sel.options[sel.selectedIndex];
        if (priceEl && opt.dataset.price) priceEl.innerHTML = opt.dataset.price;
        if (btn) {
          var ok = opt.dataset.available === 'true';
          btn.disabled = !ok;
          btn.textContent = ok ? btn.dataset.labelAdd : btn.dataset.labelSoldout;
        }
        if (opt.dataset.image) {
          var main = document.querySelector('[data-ck-main]');
          if (main) { main.src = opt.dataset.image; main.removeAttribute('srcset'); }
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', opt.value);
        window.history.replaceState({}, '', url.toString());
      }
      sel.addEventListener('change', update);
    });
  }

  /* 6. Tri de collection */
  function initSort() {
    document.querySelectorAll('[data-ck-sort]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* 7. Compteur du panier : suit les ajouts et suppressions faits sans rechargement */
  function initCartCount() {
    function render(n) {
      if (typeof n !== 'number' || n < 0) return;
      document.querySelectorAll('[data-ck-cart-count]').forEach(function (el) { el.textContent = String(n); });
    }
    function refresh() {
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) { render(c.item_count); })
        .catch(function () {});
    }
    document.addEventListener('shopify:cart:lines-update', function (e) {
      if (e && e.promise && typeof e.promise.then === 'function') {
        e.promise.then(function (res) {
          var n = res && res.cart && typeof res.cart.totalQuantity === 'number' ? res.cart.totalQuantity : null;
          if (n === null) refresh(); else render(n);
        }).catch(function () { refresh(); });
      } else {
        refresh();
      }
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  }

  function init() { initSplash(); initDrawer(); initFinder(); initGallery(); initVariants(); initSort(); initCartCount(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
